import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@core/auth/auth.guard';
import { RoutePermissionResolver } from './@core/router/route-permission.resolver';
import { PrivacyPolicyComponent } from './@core/auth/privacy-policy/privacy-policy.component';
import { TermsConditionsComponent } from './@core/auth/terms-conditions/terms-conditions.component';
import { PrivacyTermsComponent } from './@core/auth/privacy-terms/privacy-terms.component';
import { AcknowledgmentComponent } from './pages/acknowledgment/acknowledgment.component';
import { SsoCallbackComponent } from './@core/auth/sso-callback/sso-callback.component';
import { PublicHelpComponent } from './@core/auth/public-help/public-help.component';
import { TokenExpiredComponent } from './pages/verification-link-expired/verification-link-expired';


const routes: Routes = [
   { path: 'acknowledgment', component: AcknowledgmentComponent }, 
   { path: 'verification-link-expired', component: TokenExpiredComponent },
  // { path: '', redirectTo: 'login', pathMatch: 'full'},
  {
    path: 'pages',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule),
    data: {
      rootmodulenames: ['APP'],
      route: '/pages'
    },
    resolve: { permissions: RoutePermissionResolver }
  },
  {
    path: 'auth/login',
    loadChildren: () => import('@core/auth/login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'auth/system/login',
    loadChildren: () => import('@core/auth/login-no-captcha/login-no-captcha.module').then(m => m.LoginNoCaptchaModule)
  },
  {
    path: 'federatedlogin',
    loadChildren: () => import('@core/auth/federated-login/federated-login.module').then(m => m.FederatedLoginModule)
  },
  {
    path: 'sso/validate',
    loadChildren: () => import('@core/auth/sso/sso.module').then(m => m.SsoModule)
  },
  {
    path: 'sso/logout',
    loadChildren: () => import('@core/auth/federated-logout/federated-logout.module').then(m => m.FederatedLogoutModule)
  },
  {
    path: 'auth/callback',
    component: SsoCallbackComponent
  },
  {
    path: 'auth/change-password',
    loadChildren: () => import('@core/auth/change-password/change-password.module').then(m => m.ChangePasswordModule)
  },
  {
    path: 'auth/forgot-password',
    loadChildren: () => import('@core/auth/forgot-password/forgot-password.module').then(m => m.ForgotPasswordModule)
  },
  {
    path: 'privacy-policy',
    component: PrivacyPolicyComponent,
  },
  {
    path: 'terms-and-conditions',
    component: TermsConditionsComponent,
  },
  {
    path: 'terms-and-conditions-and-privacy-policy',
    component: PrivacyTermsComponent,
  },
  {
    path: 'help',
    component: PublicHelpComponent,
  },
  { path: '**', redirectTo: 'auth/callback', pathMatch: 'full' }
  // { path: '**', redirectTo: 'auth/login', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
